import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';

function ResultLayoutTogglerUI() {
    this.defaultAttrs({
        toggleLayoutSelector: '[data-search-result-toggle-layout]'
    });

    this._toggleLayout = function (evt, data) {
        let layout = $(data.el).closest('[data-search-result-toggle-layout]').attr('data-search-result-toggle-layout');
        let payload = {
            targetLayout: layout
        };
        this.trigger(document, 'ui:search:on-layout-change', payload);
    };

    this.after('initialize', function () {
        this.on('click', {
            toggleLayoutSelector: this._toggleLayout
        });
    });
}

export default  defineComponent.component(ResultLayoutTogglerUI);




// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/search-result/result-layout-toggler-ui.js